module.exports = __webpack_public_path__ + "img/hys-1.c93961f8.webp";